type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
};

export const MuxPauseIcon = (props: Props) => {
  const { width = '24', height = '24', fillColor = '#FFFFFF' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24">
      <path
        d="M6 19.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v15ZM14.5 4a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5h-3Z"
        fill={fillColor}
      />
    </svg>
  );
};
